// WeakRef is not supported in all browsers we current support (specifically
// Safari), and cannot be effectively polyfilled. The polyfill here will
// cause memory leaks for users on Safari older than 14.1.
if (
  typeof global === 'object' &&
  global &&
  typeof global['WeakRef'] === 'undefined'
) {
  global.WeakRef = (function (wm) {
    function WeakRef(target) {
      wm.set(this, target);
    }

    WeakRef.prototype.deref = function () {
      return wm.get(this);
    };

    return WeakRef;
  })(new WeakMap());
}

export default global.WeakRef;
